export default __webpack_public_path__ + "static/Screenshot-04fc2000d026076e9ed108c8fc7b1e6b.png";